import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
  dialogRoot: {
    '& .MuiDialog-paper': {
      width: theme.spacing(60)
    },
    marginBottom: '1.5rem'
  },
  dialogTitle: {
    color: theme.palette.primary.main,
    marginTop: theme.spacing(1),
    '& h2': {
      fontWeight: 400
    }
  },
  closeIcon: {
    float: 'right',
    width: '20px',
    height: '20px'
  },
  titleTypography: {
    color: theme.palette.primary.main
  },
  dialogContent: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    minHeight: 'auto',
    width: '100%'
  },
  autocomplete: {
    marginBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    '& .MuiAutocomplete-root': {
      width: '100%'
    }
  },
  noClientsTypography: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2)
  },
  gridContainer: {
    marginBottom: '1.5rem',
    direction: 'column',
    alignItems: 'stretch'
  },
  gridItem: {
    height: 44,
    letterSpacing: 1.25,
    fontSize: 16,
    fontWeight: '500',
    borderRadius: '4px',
    padding: theme.spacing(1),
    minWidth: '100%',
    margin: '0 auto',
    marginBottom: theme.spacing(1.5),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.down('lg')]: {
      fontSize: 11
    }
  },
  button: {
    height: 44,
    letterSpacing: 1.25,
    fontSize: 16,
    fontWeight: '500',
    borderRadius: '4px',
    padding: theme.spacing(1),
    minWidth: '100%',
    margin: '0 auto',
    marginBottom: theme.spacing(1.5),
    marginTop: theme.spacing(1.5),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.down('lg')]: {
      fontSize: 11
    }
  },
  confirmButton: {
    height: 44,
    letterSpacing: 1.25,
    fontSize: 16,
    fontWeight: '500',
    borderRadius: '4px',
    padding: theme.spacing(1),
    minWidth: '100%',
    margin: '0 auto',
    marginBottom: theme.spacing(1.5),
    marginTop: theme.spacing(1.5),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    borderColor: '#bdbdbd',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    '&:hover': {
      borderColor: '#FFFFFF',
      background: theme.palette.primary.dark,
      opacity: 0.8
    },
    '&:focus': {
      borderColor: '#FFFFFF',
      background: theme.palette.primary.dark,
      opacity: 0.8
    },
    [theme.breakpoints.down('lg')]: {
      fontSize: 11
    }
  }
}));
